import React from "react";
import axios from "../../../../axios";
function AssessmentNotAllowedPopup({
  setNotAllowedPopup,
  currentAssessmentId,
}) {
  let data = JSON.parse(localStorage.getItem("breathForStudent"));
  function getCurrentTime() {
    const currentTime = new Date();
    const hours = String(currentTime.getHours()).padStart(2, "0");
    const minutes = String(currentTime.getMinutes()).padStart(2, "0");
    const formattedTime = `${hours}:${minutes}`;
    return formattedTime;
  }
  const handleAssesment = async () => {
    try {
      let res = await axios.put(
        `/assessment/UpdateStartedFlag/assessmentId/${currentAssessmentId}/studentId/${data.id}`,
        {
          started_flag: "true",
          currentStatus: "Blocked",
          endTime: getCurrentTime(),
        }
      );
      res && setNotAllowedPopup(false);
    } catch (error) { }
  };
  return (
    <div className="ContainerSubmitedSucess ">
      <div className="SubContainerSubmitedSucess">
        <div className="d-flex justify-content-start gap-3 align-items-center">
          <img src="/StudentImg/BreathSchoolLogo.png" alt="icon"></img>
          <span className="sucessMsg20">Error</span>
        </div>
        <div className="mt-4">
          <p>Oops! Probably you had already started this assessment earlier.</p>
          <p>You can't enter again.</p>
          <p>Please contact teacher</p>
        </div>
        {/* <div>Do you want to Start Assessment Now?</div> */}
        <div className="d-flex justify-content-around align-items-center mt-5 widthOfContainer">
          <button
            className="okayBtnsucess"
            onClick={() => {
              handleAssesment();
            }}
          >
            Okay
          </button>
        </div>
      </div>
    </div>
  );
}

export default AssessmentNotAllowedPopup;
